import { render, staticRenderFns } from "./goodsconfirm.vue?vue&type=template&id=205dd7c2&scoped=true"
import script from "./goodsconfirm.vue?vue&type=script&lang=js"
export * from "./goodsconfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205dd7c2",
  null
  
)

export default component.exports